import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, setTokenofApp } from '../../redux/app/appActions';
import { loginRefreshToken } from '../../api/auth';
interface Props {
  currentShipmentStatus: string;
}
function ManualShipmentNav({ currentShipmentStatus }: Props) {
  let packagesActive = currentShipmentStatus !== 'route';
  let legsActive = packagesActive && currentShipmentStatus !== 'packages';
  let onRoute = currentShipmentStatus === 'route';
  let onPackage = currentShipmentStatus === 'packages';
  let onRates = currentShipmentStatus === 'legs';
  const expiredTime = localStorage.getItem('accessExpiry');
  const refreshToken = localStorage.getItem('refreshToken');
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  useEffect(() => {
    var currentTime = Date.now();
    var currentTimeStamp = Math.round(currentTime / 1000);
    if (expiredTime && currentTimeStamp > Number(expiredTime)) {
      window.scrollTo(0, 0);
      localStorage.setItem('authToken', '');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('accessExpiry');
      dispatch(setTokenofApp(''));
      dispatch(logout());
      navigate('/login');
    }

    var futureTime = currentTime + 10 * 60 * 1000;
    var futureTimeInSeconds = Math.round(futureTime / 1000);

    if (expiredTime && futureTimeInSeconds > Number(expiredTime)) {
      loginRefreshToken({ refresh: refreshToken })
        .then((response: any) => {
          if (response?.data?.is_error === false) {
            dispatch(setTokenofApp(response?.data?.content?.access));
            localStorage.setItem(
              'refreshToken',
              response?.data?.content?.refresh
            );
            localStorage.setItem(
              'accessExpiry',
              response?.data?.content?.access_expiry
            );
          }
        })
        .catch((e) => {});
    }
  }, [currentShipmentStatus]);
  return (
    <div className='row mt-4 mb-3'>
      <div className='w-full text-center'>
        <div className='row'>
          <div className='col-sm-12 col-md-4 ps-1 pe-1'>
            <h3
              className={
                onRoute
                  ? 'boldstepperhead text-start'
                  : 'steppertext ubbe-blue text-start'
              }
              id='route_label'
            >
              Step 1
            </h3>
            <div className={`${packagesActive && 'stepperBg'} progress`}>
              <div
                className={`${packagesActive && 'stepperBg'} progress`}
                role='progressbar'
                id='route_progress'
                style={{ width: '100%' }}
              ></div>
            </div>

            <div className={onRoute ? 'form-check activecheckedhead' : 'round'}>
              {!onRoute ? (
                <>
                  <input
                    type='checkbox'
                    id='checkbox'
                    checked={packagesActive}
                  />
                  <label htmlFor='checkbox'></label>
                  <div className='boldsteppertext'>Select Route</div>
                </>
              ) : (
                <div className='mt-2'>
                  <input
                    className='form-check-input activechecked '
                    type='radio'
                    name='flexRadioDefault'
                    id='flexRadioDefault2'
                    checked
                  />
                  <div className='boldsteppertext'>Select Route</div>
                </div>
              )}
            </div>
          </div>
          <div className='col-sm-12 col-md-4 ps-1 pe-1 text-center'>
            <h3
              className={
                onPackage
                  ? 'boldstepperhead text-start'
                  : 'steppertext ubbe-blue text-start'
              }
              id='packages_label'
            >
              Step 2
            </h3>
            <div className={`${legsActive && 'stepperBg'} progress`}>
              <div
                className={`${legsActive && 'stepperBg'} progress-bar`}
                role='progressbar'
                id='packages_progress'
                style={{ width: '0' }}
              ></div>
            </div>

            <div
              className={onPackage ? 'form-check activecheckedhead' : 'round'}
            >
              {!onPackage ? (
                <>
                  <input type='checkbox' id='checkbox' checked={legsActive} />
                  <label htmlFor='checkbox'></label>
                  <div
                    className={
                      packagesActive ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Select Package
                  </div>
                </>
              ) : (
                <div className='mt-2'>
                  <input
                    className='form-check-input activechecked '
                    type='radio'
                    name='flexRadioDefault'
                    id='flexRadioDefault2'
                    checked
                  />
                  <div
                    className={
                      packagesActive ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Select Package
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='col-sm-12 col-md-4 ps-1 pe-1 text-center'>
            <h3
              className={
                onRates
                  ? 'boldstepperhead text-start'
                  : 'steppertext ubbe-blue text-start'
              }
              id='rates_label'
            >
              Step 3
            </h3>
            <div
              className={`${!onRates && legsActive && 'stepperBg'} progress`}
            >
              <div
                className={`${
                  !onRates && legsActive && 'stepperBg'
                } progress-bar`}
                role='progressbar'
                id='rates_progress'
                style={{ width: '0' }}
              ></div>
            </div>

            <div className={onRates ? 'form-check activecheckedhead' : 'round'}>
              {!onRates ? (
                <>
                  <input type='checkbox' id='checkbox' checked={legsActive} />
                  <label htmlFor='checkbox'></label>
                  <div
                    className={
                      onRates ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Select Legs
                  </div>
                </>
              ) : (
                <div className='mt-2'>
                  <input
                    className='form-check-input activechecked '
                    type='radio'
                    name='flexRadioDefault'
                    id='flexRadioDefault2'
                    checked
                  />
                  <div
                    className={
                      onRates ? 'boldsteppertext' : 'normalsteppertext'
                    }
                  >
                    Select Legs
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}

export default ManualShipmentNav;
